<!-- <div class="row mb-2" *ngIf="component.element.bind_to_variable !== 'email'">
  <label class="mb-1 col-sm-4" translate>Input type</label>
  <div class="col-sm-8">
    <select
      name="input_type"
      class="form-select form-select-sm"
      [(ngModel)]="component.type"
      (ngModelChange)="onInputTypeChange($event)"
    >
      <option
        [value]="inputType.value"
        [selected]="inputType.value === component.type"
        *ngFor="let inputType of inputTypes"
        >{{ inputType.label }}</option
      >
    </select>
  </div>
</div> -->
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Formula</label>
  <div class="col-sm-12">
    <textarea class="form-control form-control-sm" [(ngModel)]="component.element.formula"></textarea>
    <p class="text-info">Ex: <code ngNonBindable>{{field_name1}} + {{field_name2}}</code></p>
  </div>
</div>
<div class="mb-2 form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.show_label" id="show_label" />
  <label for="show_label" class="form-check-label" translate>Show label</label>
</div>
<div class="mb-2 form-check">    
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.show_decimal" id="show_decimal" /> 
  <label for="show_decimal" class="form-check-label" translate>Show Decimal</label> 
</div>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Output label</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.label" />
  </div>
</div>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Placeholder text</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.placeholder_text" />
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Field name</label>
  <div class="col-sm-12">
    <input type="text" name="field_name" [(ngModel)]="component.element.field_name"
      class="form-control form-control-sm">
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Prefix</label>
  <div class="col-sm-12">
    <input type="text" name="prefix" [(ngModel)]="component.element.prefix" class="form-control form-control-sm">
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Postfix</label>
  <div class="col-sm-12">
    <input type="text" name="postfix" [(ngModel)]="component.element.postfix" class="form-control form-control-sm">
  </div>
</div>